export default __webpack_public_path__ + "static/media/avsecID.28409e50.png";